import { Directive, ElementRef, EventEmitter, HostListener, Output, input, inject } from '@angular/core';

@Directive({
  selector: '[payLibOutsideClick]',
  standalone: true,
})
export class OutsideClickDirective {
  private elementRef = inject(ElementRef);

  @Output() outsideClick: EventEmitter<MouseEvent> = new EventEmitter();
  readonly ignoreClicksOnOverlayLayer = input(false);

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    const element = event.target as HTMLElement;
    if (this.ignoreClicksOnOverlayLayer() && document.getElementsByClassName('cdk-overlay-container').item(0)?.contains(element)) {
      return;
    }

    if (!this.isOrContainsClickTarget(this.elementRef.nativeElement, element)) {
      this.outsideClick.emit(event);
    }
  }

  private isOrContainsClickTarget(element: HTMLElement, clickTarget: HTMLElement) {
    return element == clickTarget || element.contains(clickTarget);
  }
}
